// extracted by mini-css-extract-plugin
export default {"couponitemcomp__popover-hint-trigle":"nKn1e_couponitemcomp__popover-hint-trigle","max-lines-0":"BWhWE_max-lines-0","machweb-modal":"EsRpt_machweb-modal"};